import PhotoFinderCreditItemsTable from './PhotoFinderCreditItemsTable';

export default PhotoFinderCreditItemsTable;
